import { withStyles } from '@material-ui/core/styles';
import { COMMUNE_LIST_TITLE } from '../../libraries/texts';
import service from '../../services/commune-service';

import ListForm from '../maintainer/list';
import { MaintainerList as styles } from '../maintainer/styles';

export default withStyles(styles)(
  ListForm({ service, title: COMMUNE_LIST_TITLE, name: 'COMMUNE' })
);
